import React, { useEffect, useState } from 'react';
import '../../styles/Reports.css';
import CEOReport from './reports/CEOReport';
import ModulePerformanceReport from './reports/ModulePerformanceReport';
import {
  companiesAPI,
  contactsAPI,
  clientsAPI,
  jobsAPI,
  candidatesAPI,
  tasksAPI,
  userAPI,
  employeesAPI,
  invoiceAPI,
} from '../../services/api';

const Reports = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeReport, setActiveReport] = useState('ceo'); // 'ceo' or 'module'
  const [reportsData, setReportsData] = useState({
    companies: [],
    contacts: [],
    clients: [],
    jobs: [],
    candidates: [],
    tasks: [],
    users: [],
    employees: [],
    invoices: [],
  });

  useEffect(() => {
    fetchAllReportData();
  }, []);

  const fetchAllReportData = async () => {
    try {
      setLoading(true);
      setError(null);

      const [
        companiesRes,
        contactsRes,
        clientsRes,
        jobsRes,
        candidatesRes,
        tasksRes,
        usersRes,
        employeesRes,
        invoicesRes,
      ] = await Promise.all([
        companiesAPI.getAllCompanies().catch(() => ({ data: [] })),
        contactsAPI.getAllContacts().catch(() => ({ data: [] })),
        clientsAPI.getAllClients({}).catch(() => ({ data: [] })),
        jobsAPI.getAllJobs().catch(() => ({ data: [] })),
        candidatesAPI.getAllApplicationsByOrg().catch(() => ({ data: [] })),
        tasksAPI.getAllTasks().catch(() => ({ data: [] })),
        userAPI.getAllUsers().catch(() => ({ data: [] })),
        employeesAPI.getAllEmployees().catch(() => ({ data: [] })),
        invoiceAPI.getAllInvoices(localStorage.getItem('organizationId')).catch(() => ({ data: [] })),
      ]);

      setReportsData({
        companies: Array.isArray(companiesRes.data) ? companiesRes.data : [],
        contacts: Array.isArray(contactsRes.data) ? contactsRes.data : [],
        clients: Array.isArray(clientsRes.data) ? clientsRes.data : [],
        jobs: Array.isArray(jobsRes.data) ? jobsRes.data : [],
        candidates: Array.isArray(candidatesRes.data) ? candidatesRes.data : [],
        tasks: Array.isArray(tasksRes.data) ? tasksRes.data : [],
        users: Array.isArray(usersRes.data) ? usersRes.data : [],
        employees: Array.isArray(employeesRes.data) ? employeesRes.data : [],
        invoices: Array.isArray(invoicesRes.data) ? invoicesRes.data : [],
      });
    } catch (err) {
      console.error('Reports data fetch error:', err);
      setError('Failed to load reports data');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="reports-container">
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Loading reports...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="reports-container">
      {/* Header */}
      <div className="reports-header">
        <h1>📊 Business Reports</h1>
        <p>Comprehensive metrics and analysis</p>
      </div>

      {/* Report Selection */}
      <div className="reports-tabs">
        <button
          className={`tab-button ${activeReport === 'ceo' ? 'active' : ''}`}
          onClick={() => setActiveReport('ceo')}
        >
          👔 CEO Executive Report
        </button>
        <button
          className={`tab-button ${activeReport === 'module' ? 'active' : ''}`}
          onClick={() => setActiveReport('module')}
        >
          📈 Module Performance Report
        </button>
      </div>

      {/* Reports Content */}
      <div className="reports-content">
        {activeReport === 'ceo' && <CEOReport data={reportsData} />}
        {activeReport === 'module' && <ModulePerformanceReport data={reportsData} />}
      </div>

      {/* Refresh Button */}
      <div className="reports-footer">
        <button className="refresh-btn" onClick={fetchAllReportData}>
          🔄 Refresh Reports
        </button>
      </div>
    </div>
  );
};

export default Reports;
